import {
  API,
  TOKEN_KEY,
  baseURL,
  getSECURE_API,
  sendFormDataRequest
} from 'api';
import axios from 'axios';

const SECURE_API = getSECURE_API();
SECURE_API.interceptors.request.use(req => {
  req.baseURL = `${req.baseURL}/issues`;
  return req;
});

export const getAll = () => SECURE_API.get('/');

export const updateOne = ({ id, body }) =>
  SECURE_API.put(`/${id}`, {
    ...body
  });
export const deleteOne = id => SECURE_API.delete(`/${id}`);
